import { withStyles } from 'tss-react/mui';

export default function withStylesAdapter(styles) {
  return function (component) {
    return withStyles(component, styles);
  };
}
